
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's0c3b1fef418d5b74': `.`,
's132522bb7aae8035': `Rechercher une agence de voyages`,
's18478448b60cf9cf': `Dans le cas où aucune réservation n'est effectuée, j'accepte un forfait de frais de CHF 150.– (entièrement déductible lors de la réservation).`,
's1939b4eadf354f4f': `Un script indispensable (Google reCAPTCHA) n'a pas pu être chargé. Veuillez vérifier vos paramètres.`,
's1ded3fc62d4f8519': `Nous traitons vos données personnelles conformément à `,
's23b0aab96e8df173': `Heure`,
's316b0adbe5a78346': `Choisissez l'heure qui vous convient pour votre rendez-vous.`,
's332ab4f9597c80af': `Prénom`,
's3a09134dbe99ca77': `Choisir une date`,
's3d1affb5392426a7': `Une erreur s'est malheureusement produite. Veuillez réessayer plus tard.`,
's456078dbb63e9c46': `Téléphone`,
's4f78b4b59795bc5e': `par téléphone`,
's51a82303f3cba908': `Je souhaite recevoir la newsletter personnalisée relative aux produits propres et partenaires conformément à la déclaration de protection des données. Ce consentement peut être révoqué à tout moment avec effet pour l'avenir via le lien de désinscription dans la newsletter.`,
's595a9a3948ff6918': `E-Mail`,
's5e73f98199ac0dec': `Téléphone`,
's5f48682995b76e99': `Madame`,
's62a24ababe044eac': `Comment pouvons-nous vous conseiller ?`,
's64361086e22178a8': `C'est ainsi que j'envisage mon voyage`,
's6e96f924f8fde70e': `en agence de voyages`,
's795bfd73603118ed': `Veuillez noter que votre rendez-vous de consultation ne sera définitivement confirmé qu'après notre reconfirmation. Nous vous contacterons au plus vite et nous réjouissons de vous accueillir chez nous.`,
's84f56833762a8dde': `Choisissez une date appropriée`,
's979e005caa23191c': `par call vidéo`,
's98810821fd49d570': `Monsieur`,
's9d70decbe00ecee5': `notre déclaration de protection des données`,
's9eae752ec1d6eaed': `Laissez votre besoin d'évasion vous envahir – la planification du voyage de vos rêves est sur le point de commencer.`,
'sa2cda9e57e677b1a': `Ensemble, transformons vos rêves de vacances en vacances de rêve, où, quand et comme vous le souhaitez.`,
'sbde2c889ca41987f': `Vos coordonnées`,
'sc0f2e2a0357d674b': `Coordonnées`,
'sc288aaa98d1d805f': `Civilité`,
'sc38a7808b5c16b9e': `Réserver un rendez-vous conseil`,
'sc78f6722e16a6915': `Divers`,
'sc8b4b07c3d153566': `Veuillez choisir`,
'sd1ae39c808c62dc1': `Nom`,
'sd6be36b3da2b363e': `Pour toute question concernant le rendez-vous de consultation, contactez-moi par`,
'sd8df04bd3cea1743': `Envoyer`,
'sdfd268b3ab4f11bb': `Confirmer l’E-Mail`,
'se2be8581e4931555': `Choisissez votre agence de voyages`,
'sed9254d62dad0502': `E-Mail`,
'sf22261518dcb241a': `Votre rendez-vous souhaité`,
'sf470f1e814975856': `Choisir l'heure`,
'sfc2b2254de1bc4e8': `Merci beaucoup pour votre demande`,
    };
  